function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect, useRef } from 'react';
import { Row, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormattedNumberInput, Table } from '@rd-web-markets/shared/dist/util';
import { DatePicker } from '@rd-web-markets/shared/dist/util/date';
import elsterAssetInstancesService from '../../../../services/elster/elster_asset_instances.service';
import ElsterAssetForm from './ElsterAssetForm';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import { AddButton, DeleteButtonSquare } from '@rd-web-markets/shared/dist/util/buttons';
import { SELECTED_ROW_DIMMED_CLASS } from '../../../../constants';
const ElsterAssets = _ref => {
  var _selectedProject$proj;
  let {
    selectedProject
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    search
  } = useLocation();
  const [listLoading, setListLoading] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [selectedAssetInstance, setSelectedAssetInstance] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const hasFetchedRef = useRef(false);
  const projectElsterDetailId = selectedProject === null || selectedProject === void 0 || (_selectedProject$proj = selectedProject.project_elster_detail) === null || _selectedProject$proj === void 0 ? void 0 : _selectedProject$proj.id;
  const reportId = selectedProject === null || selectedProject === void 0 ? void 0 : selectedProject.id;
  const {
    assetInstances,
    setAssetInstances,
    fetchAssetInstances,
    assetInstance,
    setAssetInstance,
    fetchAssetInstance,
    updateAssetInstance,
    updateAsset,
    createAssetInstance,
    deleteAssetInstance
  } = elsterAssetInstancesService.useCrud(projectElsterDetailId, reportId, setListLoading, setDetailLoading, setSelectedAssetInstance, false // Don't fetch immediately
  );
  const isAssetsTabActive = new URLSearchParams(search).get('sub_tab1') === 'assets';

  // Fetch list only when first entering the tab
  useEffect(() => {
    if (isAssetsTabActive && projectElsterDetailId && !hasFetchedRef.current) {
      hasFetchedRef.current = true;
      fetchAssetInstances();
    }

    // Reset ref when project changes or tab becomes inactive
    if (!isAssetsTabActive || !projectElsterDetailId) {
      hasFetchedRef.current = false;
    }
  }, [isAssetsTabActive, projectElsterDetailId, fetchAssetInstances]);
  useEffect(() => {
    !isAssetsTabActive && setSelectedAssetInstance(null) && setAssetInstance(null);
  }, [isAssetsTabActive, setSelectedAssetInstance, setAssetInstance]);
  const editAsset = (e, assetInstanceId) => {
    e.preventDefault();
    if ((assetInstance === null || assetInstance === void 0 ? void 0 : assetInstance.id) !== assetInstanceId) {
      fetchAssetInstance({
        projectElsterDetailId,
        assetInstanceId
      });
    }
    setHasUnsavedChanges(false);
    setSelectedAssetInstance(assetInstanceId);
  };
  const closeForm = () => {
    setHasUnsavedChanges(false);
    setSelectedAssetInstance(null);
    setAssetInstance(null);
  };
  const deleteAssetHandler = async assetInstanceToDelete => {
    var _assetInstanceToDelet;
    if (window.confirm(t("".concat(window.MARKET_CONSTANTS.DELETE_CONFIRMATION_MESSAGE)) + ': ' + ((_assetInstanceToDelet = assetInstanceToDelete.asset) === null || _assetInstanceToDelet === void 0 ? void 0 : _assetInstanceToDelet.name))) {
      closeForm();
      deleteAssetInstance(assetInstanceToDelete);
    }
  };
  const change = e => {
    let value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    // Convert number fields to numbers
    const numberFields = ['a9_number_of_months_not_exclusive_for_rd', 'a11_value_at_time_of_sale', 'a13_acquisition_cost', 'a15_value_at_end_of_previous_fiscal_year', 'a16_value_at_end_of_this_fiscal_year'];
    if (numberFields.includes(e.target.name) && value !== '') {
      value = parseInt(value, 10);
    }

    // Handle date fields - value is already a Date object from DatePicker

    const fieldName = e.target.name;
    setHasUnsavedChanges(true);

    // Determine if field belongs to asset or assetInstance
    const assetFields = ['name', 'is_asset_eligible_for_all_periods', 'a1_type_and_description', 'a2_asset_after_20240327', 'a3_acquisition_date', 'a4_needed_for_rd', 'a5_movable', 'a6_belongs_to_fixed_asset', 'a7_internal_only', 'ayming_comment_guidance_feeling'];
    if (assetFields.includes(fieldName)) {
      // Update asset
      setAssetInstance(_objectSpread(_objectSpread({}, assetInstance), {}, {
        asset: _objectSpread(_objectSpread({}, assetInstance.asset), {}, {
          [fieldName]: value
        })
      }));
    } else {
      // Update assetInstance
      setAssetInstance(_objectSpread(_objectSpread({}, assetInstance), {}, {
        [fieldName]: value
      }));
    }
  };
  const submit = async () => {
    var _assetInstance$asset;
    if (!assetInstance) return;

    // Check if this is a new asset (no id) or existing asset
    if (!((_assetInstance$asset = assetInstance.asset) !== null && _assetInstance$asset !== void 0 && _assetInstance$asset.id)) {
      var _assetInstance$asset2, _assetInstance$asset3, _assetInstance$asset4, _assetInstance$asset5, _assetInstance$asset6, _assetInstance$asset7, _assetInstance$asset8, _assetInstance$asset9, _assetInstance$asset0, _assetInstance$asset1;
      // Create new asset instance
      const assetData = {
        name: (_assetInstance$asset2 = assetInstance.asset) === null || _assetInstance$asset2 === void 0 ? void 0 : _assetInstance$asset2.name,
        ayming_comment_guidance_feeling: (_assetInstance$asset3 = assetInstance.asset) === null || _assetInstance$asset3 === void 0 ? void 0 : _assetInstance$asset3.ayming_comment_guidance_feeling,
        is_asset_eligible_for_all_periods: (_assetInstance$asset4 = assetInstance.asset) === null || _assetInstance$asset4 === void 0 ? void 0 : _assetInstance$asset4.is_asset_eligible_for_all_periods,
        a1_type_and_description: (_assetInstance$asset5 = assetInstance.asset) === null || _assetInstance$asset5 === void 0 ? void 0 : _assetInstance$asset5.a1_type_and_description,
        a2_asset_after_20240327: (_assetInstance$asset6 = assetInstance.asset) === null || _assetInstance$asset6 === void 0 ? void 0 : _assetInstance$asset6.a2_asset_after_20240327,
        a3_acquisition_date: (_assetInstance$asset7 = assetInstance.asset) === null || _assetInstance$asset7 === void 0 ? void 0 : _assetInstance$asset7.a3_acquisition_date,
        a4_needed_for_rd: (_assetInstance$asset8 = assetInstance.asset) === null || _assetInstance$asset8 === void 0 ? void 0 : _assetInstance$asset8.a4_needed_for_rd,
        a5_movable: (_assetInstance$asset9 = assetInstance.asset) === null || _assetInstance$asset9 === void 0 ? void 0 : _assetInstance$asset9.a5_movable,
        a6_belongs_to_fixed_asset: (_assetInstance$asset0 = assetInstance.asset) === null || _assetInstance$asset0 === void 0 ? void 0 : _assetInstance$asset0.a6_belongs_to_fixed_asset,
        a7_internal_only: (_assetInstance$asset1 = assetInstance.asset) === null || _assetInstance$asset1 === void 0 ? void 0 : _assetInstance$asset1.a7_internal_only
      };
      const elsterAssetInstanceData = {
        a8_used_for_fiscal_year_and_rd: assetInstance.a8_used_for_fiscal_year_and_rd,
        a9_number_of_months_not_exclusive_for_rd: assetInstance.a9_number_of_months_not_exclusive_for_rd,
        a10_was_asset_sold_in_this_fiscal_year: assetInstance.a10_was_asset_sold_in_this_fiscal_year,
        a11_value_at_time_of_sale: assetInstance.a11_value_at_time_of_sale,
        a12_date_of_sale: assetInstance.a12_date_of_sale,
        a13_acquisition_cost: assetInstance.a13_acquisition_cost,
        a14_formed_under_estg: assetInstance.a14_formed_under_estg,
        a15_value_at_end_of_previous_fiscal_year: assetInstance.a15_value_at_end_of_previous_fiscal_year,
        a16_value_at_end_of_this_fiscal_year: assetInstance.a16_value_at_end_of_this_fiscal_year,
        a17_additional_funding_applied_or_granted: assetInstance.a17_additional_funding_applied_or_granted,
        eligible_for_this_period: assetInstance.eligible_for_this_period
      };
      await createAssetInstance({
        asset: assetData,
        elster_asset_instance: elsterAssetInstanceData
      });

      // The create method already sets selectedAssetInstance, which triggers the useEffect to fetch full data
    } else {
      // Update existing asset instance
      const updatedAsset = await updateAsset(assetInstance.asset);
      const instanceData = _objectSpread(_objectSpread({}, assetInstance), {}, {
        asset: updatedAsset
      });
      await updateAssetInstance(instanceData);
    }
    setHasUnsavedChanges(false);
  };
  if (listLoading) return /*#__PURE__*/React.createElement(Loader, {
    type: "spinner"
  });
  const headers = [{
    text: t('name_of_asset')
  }, {
    text: t('a1_type_and_description')
  }, {
    text: t('a3_acquisition_date')
  }, {
    text: t('a13_acquisition_cost')
  }, {
    text: t('eligible_for_this_period')
  }, {
    text: t('open_asset_detail')
  }, {
    text: t('delete')
  }];
  const buildRow = assetInstanceItem => {
    var _assetInstanceItem$as, _assetInstanceItem$as2;
    const columns = [(_assetInstanceItem$as = assetInstanceItem.asset) === null || _assetInstanceItem$as === void 0 ? void 0 : _assetInstanceItem$as.name, (_assetInstanceItem$as2 = assetInstanceItem.asset) === null || _assetInstanceItem$as2 === void 0 ? void 0 : _assetInstanceItem$as2.a1_type_and_description, /*#__PURE__*/React.createElement(DatePicker, {
      key: "a3-".concat(assetInstanceItem.id),
      selected: assetInstanceItem.asset.a3_acquisition_date,
      disabled: true
    }), /*#__PURE__*/React.createElement(FormattedNumberInput, {
      key: "cost-".concat(assetInstanceItem.id),
      thousandSeparator: ".",
      decimalSeparator: ",",
      value: assetInstanceItem.a13_acquisition_cost,
      name: "a13_acquisition_cost",
      "data-testid": "a13_acquisition_cost-test-id",
      type: "text",
      size: "sm",
      className: "text-center",
      disabled: true
    }), assetInstanceItem.eligible_for_this_period ? t('yes') : t('no'), /*#__PURE__*/React.createElement(Button, {
      key: "link-".concat(assetInstanceItem.id),
      variant: "link",
      onClick: e => editAsset(e, assetInstanceItem.id),
      disabled: !!selectedAssetInstance,
      className: "p-0"
    }, t('to_asset_details')), /*#__PURE__*/React.createElement(DeleteButtonSquare, {
      key: "delete-".concat(assetInstanceItem.id),
      onClick: () => deleteAssetHandler(assetInstanceItem)
    })];
    return {
      key: assetInstanceItem.id,
      columns: columns,
      className: "text-center ".concat(assetInstanceItem.id === selectedAssetInstance ? SELECTED_ROW_DIMMED_CLASS : '')
    };
  };
  const rows = (assetInstances === null || assetInstances === void 0 ? void 0 : assetInstances.map(assetInstanceItem => buildRow(assetInstanceItem))) || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end pb-3"
  }, !selectedAssetInstance && /*#__PURE__*/React.createElement(AddButton, {
    onClick: () => {
      setHasUnsavedChanges(false);
      setSelectedAssetInstance('new');
      setAssetInstance({
        asset: {},
        a8_used_for_fiscal_year_and_rd: null,
        a9_number_of_months_not_exclusive_for_rd: null,
        a10_was_asset_sold_in_this_fiscal_year: null,
        a11_value_at_time_of_sale: null,
        a12_date_of_sale: null,
        a13_acquisition_cost: null,
        a14_formed_under_estg: null,
        a15_value_at_end_of_previous_fiscal_year: null,
        a16_value_at_end_of_this_fiscal_year: null,
        a17_additional_funding_applied_or_granted: null,
        eligible_for_this_period: null
      });
    },
    variant: "primary",
    text: t('add_new_asset'),
    className: "mx-2"
  })), !(assetInstances !== null && assetInstances !== void 0 && assetInstances.length) && !selectedAssetInstance ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement("div", {
    className: "text-center p-3"
  }, t('no_assets_found'))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Table, {
    headers: headers,
    rows: rows,
    opts: {
      bordered: false,
      striped: false,
      responsive: false,
      hover: true
    }
  }))), selectedAssetInstance && /*#__PURE__*/React.createElement(ElsterAssetForm, {
    assetInstance: assetInstance,
    closeForm: closeForm,
    loading: detailLoading,
    change: change,
    submit: submit,
    hasUnsavedChanges: hasUnsavedChanges,
    setHasUnsavedChanges: setHasUnsavedChanges
  }));
};
export default ElsterAssets;